module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("av4p0"))).then(() => parcelRequire('8rm4T'));